export const API_URL =
  process.env.REACT_APP_DEPLOYMENT === "production"
    ? "https://gutslrdas7.execute-api.us-west-2.amazonaws.com/production/api/v1"
    : "https://785rsguda4.execute-api.us-west-2.amazonaws.com/development/api/v1";
// "http://localhost:8001/api/v1";

export const NWDI_API_URL =
  process.env.REACT_APP_DEPLOYMENT === "production"
    ? "https://y86z5ldfie.execute-api.us-west-2.amazonaws.com/prod"
    : "https://mtpf8tbavd.execute-api.us-west-2.amazonaws.com/dev";

export const LIMIT = 10000;

export const NWIS_API_URL = (site_no) =>
  `https://waterservices.usgs.gov/nwis/site/?format=rdb&sites=${site_no}&siteOutput=expanded&siteStatus=all`;

export const SCIENCEBASE_API_URL = (id) =>
  `https://www.sciencebase.gov/catalog/item/${id}?format=json`;

export const initialDataState = {
  nonNgwosSites: {
    location: `${NWDI_API_URL}/sites`,
    data: null,
    filterable: true,
    filteredData: null,
    defaultColumns: [
      "site_name",
      "site_number",
      "latitude",
      "longitude",
      "site_cat_1",
      "site_transmitting",
      "ngwos_basin",
      "sw_streamflow_category",
      "sw_streamflow_statcode",
      "sw_inc_dec",
      "sw_nws_floodstage",
    ],
    uniqueIdField: "site_number"
  },
  hivisCameras: {
    location:
      "https://ngwos-app-data.s3.us-west-2.amazonaws.com/hivis_cameras.json.gz",
    data: null,
  },
  ngwosBasins: {
    location:
      "https://ngwos-app-data.s3.us-west-2.amazonaws.com/aoi/ngwos_hucs.geojson.gz",
    data: null,
  },
  iwaasBasins: {
    location:
      "https://ngwos-app-data.s3.us-west-2.amazonaws.com/aoi/iwaas_hucs.geojson.gz",
    data: null,
  },
  activities: {
    location: `${API_URL}/activities`,
    data: null,
    endpoint: "activities",
  },
  activityStatuses: {
    location: `${API_URL}/activity_statuses`,
    data: null,
    endpoint: "activity_statuses",
  },
  basins: {
    location: `${API_URL}/basins`,
    data: null,
    endpoint: "basins",
  },
  basinRoles: {
    location: `${API_URL}/roles/basin`,
    data: null,
    endpoint: "roles/basin",
  },
  dataFormats: {
    location: `${API_URL}/data_formats`,
    data: null,
    endpoint: "data_formats",
  },
  dataTypes: {
    location: `${API_URL}/data_types`,
    data: null,
    endpoint: "data_types",
  },
  datasets: {
    location: `${API_URL}/datasets`,
    data: null,
    endpoint: "datasets",
  },
  datums: {
    location: `${API_URL}/datums`,
    data: null,
    endpoint: "datums",
  },
  domains: {
    location: `${API_URL}/domains`,
    data: null,
    endpoint: "domains",
  },
  institutions: {
    location: `${API_URL}/institutions`,
    data: null,
    endpoint: "institutions",
  },
  metadataStandards: {
    location: `${API_URL}/metadata_standards`,
    data: null,
    endpoint: "metadata_standards",
  },
  parameters: {
    location: `${API_URL}/parameters`,
    data: null,
    endpoint: "parameters",
  },
  people: {
    location: `${API_URL}/people`,
    data: null,
    endpoint: "people",
  },
  projects: {
    location: `${API_URL}/projects`,
    data: null,
    endpoint: "projects",
  },
  projectRoles: {
    location: `${API_URL}/roles/project`,
    data: null,
    endpoint: "roles/project",
  },
  releaseStatuses: {
    location: `${API_URL}/release_statuses`,
    data: null,
    endpoint: "release_statuses",
  },
  sites: {
    location: `${API_URL}/sites`,
    data: null,
    endpoint: "sites",
    filteredData: null,
  },
  siteStatuses: {
    location: `${API_URL}/site_statuses`,
    data: null,
    endpoint: "site_statuses",
  },
  siteTypes: {
    location: `${API_URL}/site_types`,
    data: null,
    endpoint: "site_types",
  },
  tasks: {
    location: `${API_URL}/tasks`,
    data: null,
    endpoint: "tasks",
  },
  temporalFrequencies: {
    location: `${API_URL}/temporal_frequencies`,
    data: null,
    endpoint: "temporal_frequencies",
  },
  updateFrequencies: {
    location: `${API_URL}/update_frequencies`,
    data: null,
    endpoint: "update_frequencies",
  },
  updateTypes: {
    location: `${API_URL}/update_types`,
    data: null,
    endpoint: "update_types",
  },
  variables: {
    location: `${API_URL}/variables`,
    data: null,
    endpoint: "variables",
  },
};
